var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.quiz
    ? _c(
        "BaseCard",
        _vm._b(
          {
            scopedSlots: _vm._u(
              [
                _vm.showThumbnail
                  ? {
                      key: "topLeft",
                      fn: function () {
                        return [_c("QuizThumbnail", { attrs: { rounded: "" } })]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          "BaseCard",
          {
            to: _vm.to,
            title: _vm.title,
            collectionTitle: _vm.collectionTitle,
            completedLabel: _vm.completedLabel,
            inProgressLabel: _vm.inProgressLabel,
            reportVisible: _vm.reportVisible,
          },
          false
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }